module.exports = __webpack_public_path__ + "assets/GT-America-Extended-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GT-America-Extended-Bold.woff
// module id = 992
// module chunks = 19